export default __webpack_public_path__ + "static/media/gallery-wip-emitter_03.1bb2e6c2.jpg";